module.exports = __webpack_public_path__ + "static/media/Home Page_website-16.513bf9ce.png";